/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreatePoolCoinAddressRequest { 
    coinId?: number;
    firstAddress?: string | null;
    secondAddress?: string | null;
    thirdAddress?: string | null;
}

